/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Caption_Style_All_HelpInputs */



/**
* | output |
* | --- |
* | "Update the caption style of all events in the selected event group" |
*
* @param {Apply_Caption_Style_All_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_caption_style_all_help = /** @type {((inputs?: Apply_Caption_Style_All_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Caption_Style_All_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour le style de tous les événements du groupe sélectionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisieren Sie den Beschriftungsstil aller Ereignisse in der ausgewählten Ereignisgruppe.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna lo stile della didascalia di tutti gli eventi nel gruppo di eventi selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить стиль подписей всех событий в выбранной группе событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar el estilo de subtítulo de todos los eventos en el grupo de eventos seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新所选事件组中所有事件的标题样式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベント グループ内のすべてのイベントのキャプション スタイルを更新します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट समूह में सभी इवेंट्स के कैप्शन स्टाइल को अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualize o estilo da legenda de todos os eventos no grupo de eventos selecionado.")
	return /** @type {LocalizedString} */ ("Update the caption style of all events in the selected event group")
});